import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import React from "react";
import {
  closeDialog,
  openDialog,
} from "../../../components/dialog/dialogSlice";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import AppDialog, {
  DialogCloseButton,
} from "../../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import IconButton from "../../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import FormTextField from "../../../components/formFields/FormTextField";
import {
  requiredValidator,
  skipValidator,
} from "../../../components/formFields/CommonValidator";
import { setTransportDeleteIndex } from "../quotationSlice";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import FormNumericTextField from "../../../components/formFields/FormNumericTextField";
import { IVehicleType } from "../../vehicletype/vehicletypeModel";

const QuotationTransportArray = (
  fieldArrayRenderProps: FieldArrayRenderProps
) => {
  const dispatch = useAppDispatch();
  const TransportDeleteIndex = useAppSelector(
    (state) => state.quotation.TransportDeleteIndex
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const VehicleTypeList = useAppSelector(
    (state) => state.vehicleType.VehicleTypeList
  );

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("transportDeleteDialog"));
    dispatch(setTransportDeleteIndex(index));
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setTransportDeleteIndex(-1));
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        VehicleTypeID: null,
        Place: "",
        FromDate: "",
        ToDate: "",
        Rate: null,
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {!fieldArrayRenderProps.value || fieldArrayRenderProps?.value?.length < 1
        ? pushElementInarray()
        : null}
      {dialogName === "transportDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Transport"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TransportDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map(
          (Transportations: any, index: number) => (
            <GridLayoutItem key={index}>
              <Card className="fieldarray-card">
                <GridLayout
                  style={{ marginRight: 25 }}
                  gap={{ rows: 0, cols: 5 }}
                  cols={[
                    { width: "20%" },
                    { width: "20%" },
                    { width: "19%" },
                    { width: "19%" },
                    { width: "17%" },
                    { width: "5%" },
                  ]}
                >
                  <GridLayoutItem>
                    <Field
                      name={`Transportations.${index}.VehicleTypeID`}
                      label="Vehicle Type"
                      placeholder="Vehicle Type"
                      component={FormSelectionField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.FromDate ||
                        fieldArrayRenderProps?.value[index]?.ToDate ||
                        fieldArrayRenderProps?.value[index]?.Rate
                          ? requiredValidator
                          : skipValidator
                      }
                      options={VehicleTypeList?.map(
                        (vehicletype: IVehicleType) => {
                          return {
                            value: vehicletype?.ID,
                            label: vehicletype?.VehicleType,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Transportations.${index}.Place`}
                      label="Place"
                      placeholder="Place"
                      component={FormTextField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.VehicleTypeID ||
                        fieldArrayRenderProps?.value[index]?.FromDate ||
                        fieldArrayRenderProps?.value[index]?.ToDate ||
                        fieldArrayRenderProps?.value[index]?.Rate
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Transportations.${index}.FromDate`}
                      label="From Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={
                        fieldArrayRenderProps?.value[index]?.VehicleTypeID ||
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.ToDate ||
                        fieldArrayRenderProps?.value[index]?.Rate
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Transportations.${index}.ToDate`}
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={moment(
                        fieldArrayRenderProps.formRenderProps.valueGetter(
                          `Transportations.${index}.FromDate`
                        )
                      ).toDate()}
                      component={FormDatePicker}
                      validator={
                        fieldArrayRenderProps?.value[index]?.VehicleTypeID ||
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.FromDate ||
                        fieldArrayRenderProps?.value[index]?.Rate
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      wrapperClassName="right-aligned-field"
                      name={`Transportations.${index}.Rate`}
                      label="Rate"
                      placeholder="0"
                      component={FormNumericTextField}
                      validator={
                        fieldArrayRenderProps?.value[index]?.VehicleTypeID ||
                        fieldArrayRenderProps?.value[index]?.Place ||
                        fieldArrayRenderProps?.value[index]?.FromDate ||
                        fieldArrayRenderProps?.value[index]?.ToDate
                          ? requiredValidator
                          : skipValidator
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem className="text-end">
                    <IconButton
                      onClick={() => handleOpenDeleteDialog(index)}
                      disabled={fieldArrayRenderProps.value.length === 1}
                      themeColor={"error"}
                      size={"small"}
                      fillMode={"solid"}
                      type="button"
                      style={{
                        height: 30,
                        width: 30,
                        marginTop: 35,
                      }}
                      icon={MdDelete}
                      iconClassName="absolute-position"
                      iconStyle={{ fontSize: "16px" }}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </Card>
            </GridLayoutItem>
          )
        )}

      <GridLayoutItem style={{ textAlign: "end" }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Transport
        </Button>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default QuotationTransportArray;
